export const getPartnerLinePrice = (ticket, line, promo) => {
  if (!ticket) return { ...line, unitPrice: 0, sum: 0 };
  const discount = promo?.ticketDiscounts?.find(
    (entry) => String(entry.ticketId) === String(ticket.id),
  );
  const percentage = Number(discount?.discountValue ?? discount?.discountPercentage ?? 100);
  const optionDelta = (line.optionSelections || []).reduce((total, selection) => {
    const group = (ticket.options || []).find(
      (entry) => String(entry.id) === String(selection.groupId),
    );
    const value = (group?.values || []).find(
      (entry) => String(entry.id) === String(selection.valueId),
    );
    return total + Number(value?.priceDelta || 0);
  }, 0);
  const unitCents = Math.round(
    Math.max(0, Number(ticket.price || 0) + optionDelta) * (100 - percentage),
  );
  return { ...line, unitPrice: unitCents / 100, sum: (unitCents * Number(line.number || 0)) / 100 };
};
